import { useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let url = useDataValue({
    context: 'order_status',
    path: 'tracking_url',
    viewPath: props.viewPath,
  })

  return function onClick() {
    window.open(url, '_blank')
  }
}
